export const JOB_POST_REQUEST = "USER_REGISTER_REQUEST";
export const JOB_POST_SUCCESS = "JOB_POST_SUCCESS";
export const JOB_EDIT = "JOB_EDIT";
export const JOB_POST_FAIL = "JOB_POST_FAIL";
export const JOB_POST_REST = "JOB_POST_REST";



export const GET_JOBLIST_REQUEST = "GET_JOBLIST_REQUEST";
export const GET_ALLJOB_SUCCESS = "GET_ALLJOB_SUCCESS";
export const GET_SINGLE_JOB_SUCCESS = "GET_SINGLE_JOB_SUCCESS";
export const GET_JOBLIST_FAIL = "GET_JOBLIST_FAIL";

export const JOB_DELETE_REQUEST = "NOTES_DELETE_REQUEST";
export const JOB_DELETE_SUCCESS = "NOTES_DELETE_SUCCESS";
export const JOB_DELETE_FAIL = "NOTES_DELETE_FAIL";
